export default "__VITE_ASSET__UpWHGSub__"